import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
} from '@angular/core';
import { AllTableTabLabelComponent } from './all-table-tab-label.component';
import { AllTableTabBodyComponent } from './all-table-tab-body.component';
import { ModifierType } from '@prlw/core/monitor/types/common';

@Component({
  selector: 'prlw-all-table-tab-item',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllTableTabItemComponent {
  @Input() public label!: ModifierType;
  @Input() public disabled!: boolean | null;

  @ContentChild(AllTableTabBodyComponent)
  public readonly bodyComponent!: AllTableTabBodyComponent;
  @ContentChild(AllTableTabLabelComponent)
  public readonly labelComponent!: AllTableTabLabelComponent;
}
